import React, { memo, useRef } from 'react';
import { selectErrorLabels, selectIsFullCart } from 'features/carrello/carrelloSelectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { BannerInformationPropsType } from 'components/bannerInformation';
import { CarrelloCombinazioniDesktop } from 'features/carrello/carrelloSheet/components/carrelloCombinazioniDesktop';
import { CarrelloFooterContainer } from 'features/carrello/carrelloFooterContainer';
import { CarrelloFooterSistema } from 'features/carrello/carrelloFooterSistema';
import { MovimentiTipoScommessaEnum } from 'types/swagger';
import { Sistema } from 'features/carrello/types';
import { SportTicketAvvenimento } from 'features/sport/components/sportTicket/utils/calcoloCarrello/types';
import { SportTicketItem } from 'features/sport/components/sportTicket/components/sportTicketItem';
import { dismissChangedQuoteWarning } from 'features/sport/components/sportTicket/utils/calcoloCarrello/utils';
import { selectErrori } from 'features/sport/components/sportTicket/sportTicketSelectors';
import styles from './SportTicketSistema.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type SportTicketSistemaProps = {
  bonus: number;
  prezzo: number;
  sistemi: Sistema[];
  avvenimenti: SportTicketAvvenimento[];
  possibileVincitaMin: number;
  possibileVincitaMax: number;
  possibileVincitaMinWithBonus: number;
  possibileVincitaMaxWithBonus: number;
};

export const SportTicketSistema = memo(function SportTicketSistema({
  bonus,
  prezzo,
  avvenimenti,
  possibileVincitaMin,
  possibileVincitaMax,
  possibileVincitaMinWithBonus,
  possibileVincitaMaxWithBonus,
}: SportTicketSistemaProps) {
  const footerRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const errori = useTypedSelector(selectErrori);
  const isFullCart = useTypedSelector(selectIsFullCart);
  const errorsLabels = useTypedSelector(selectErrorLabels);
  const { isMobile } = useWindowSize();

  return (
    <>
      {isFullCart && (
        <>
          <div className={styles.wrapper}>
            <div className={styles.list}>
              {avvenimenti?.map((avvenimento, index) => (
                <SportTicketItem key={`sport-ticket-${avvenimento}-${index}-sistema`} avvenimento={avvenimento} />
              ))}
            </div>
          </div>
          {!isMobile && <CarrelloCombinazioniDesktop />}
        </>
      )}
      <CarrelloFooterContainer
        ref={footerRef}
        type={MovimentiTipoScommessaEnum.Sport}
        errors={
          errori.erroriCarrello?.length > 0 && Array.isArray(errori.erroriCarrello)
            ? Array.from(errori.erroriCarrello, (errore) => {
                const foundError = errorsLabels?.find((errorLabel) => errorLabel.key === errore.type);
                return {
                  type: foundError?.tipo as BannerInformationPropsType['type'],
                  text: errore.value
                    ? foundError?.value.replace(/{{valore}}/, errore.value.toString())!
                    : foundError?.value!,
                  visible: true,
                  layoutType: 'small',
                };
              })
            : errori.erroriVendita?.length > 0 && Array.isArray(errori.erroriVendita)
            ? Array.from(errori.erroriVendita, (errore) => {
                const foundError = errorsLabels.find((errorLabel) => errorLabel.key === errore.type);
                return {
                  type: foundError?.tipo as BannerInformationPropsType['type'],
                  text: foundError?.value!,
                  visible: true,
                  layoutType: 'small',
                  isDismissible: true,
                  actionOnDismiss: dismissChangedQuoteWarning({
                    dispatcher: dispatch,
                    error: foundError!,
                  }),
                };
              })
            : undefined
        }
      >
        <CarrelloFooterSistema
          bonus={bonus}
          prezzo={prezzo}
          possibileVincitaMin={possibileVincitaMin}
          possibileVincitaMax={possibileVincitaMax}
          possibileVincitaMinWithBonus={possibileVincitaMinWithBonus}
          possibileVincitaMaxWithBonus={possibileVincitaMaxWithBonus}
        />
      </CarrelloFooterContainer>
    </>
  );
});